export const portfolioData = [
  {
    title: 'Car Game',
    subtitle: 'See Details',
    href: '#',
    src: '/images/portfolio_7.png',
  },
  {
    title: 'Decaswap',
    subtitle: 'See Details',
    href: 'https://www.decaswap.com/',
    src: '/images/portfolio_5.png',
  },
  {
    title: 'Hoopas',
    subtitle: 'See Details',
    href: 'https://www.box.3pixl.com/',
    src: '/images/portfolio_6.png',
  },
  {
    title: 'Me DO DO',
    subtitle: 'See Details',
    href: 'https://airdrop.medodocoin.com/',
    src: '/images/portfolio_3.png',
  },
];